exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".king-trial{margin-bottom:27.733px;margin-bottom:1.733333rem}.king-trial .title-pic{width:106.666px;width:6.666667rem;height:13.226px;height:.826667rem;margin-bottom:5.546px;margin-bottom:.346667rem}.king-trial .kings{width:155.733px;width:9.733333rem;height:69.546px;height:4.346667rem}.king-trial .kings .gift-btn{width:40.533px;width:2.533333rem;height:31.146px;height:1.946667rem;top:60%;right:-4.266px;right:-.266667rem;margin-top:-20.16px;margin-top:-1.26rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template/client/smsgz/assets","/static":"/data/efun/gw-template/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-810533ee","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/components/index/king-trial.vue
// module id = u0vJ
// module chunks = 0